export default {"src":"/_next/static/media/text-block-103.465d9772.svg","height":372,"width":1184,"blurWidth":0,"blurHeight":0};